/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Air_Handler_Unit_Exceptional_Planning_Copy_RequiredInputs */



/**
* | output |
* | --- |
* | "Select at least one unit" |
*
* @param {Air_Handler_Unit_Exceptional_Planning_Copy_RequiredInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const air_handler_unit_exceptional_planning_copy_required = /** @type {((inputs?: Air_Handler_Unit_Exceptional_Planning_Copy_RequiredInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Air_Handler_Unit_Exceptional_Planning_Copy_RequiredInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Select at least one unit")
	return /** @type {LocalizedString} */ ("Sélectionnez au moins un équipement")
});